/* PROTEAM: close only the current cross-sell card, not future cart suggestions.
   Shopify re-renders the card when the cart changes, so recommendations resume.
   No cart mutations, additional requests, or impact on checkout. */
(() => {
  'use strict';
  if (window.__pdhCartAddonDismissInstalled) return;
  window.__pdhCartAddonDismissInstalled = true;

  // Undo the former session-wide opt-out, including for returning customers.
  document.documentElement.classList.remove('pdh-cart-addon-dismissed');
  try {
    window.sessionStorage.removeItem('proteam-cart-addon-dismissed');
  } catch (_) {
    // Works even when browsers block storage.
  }

  document.addEventListener('click', (event) => {
    const button = event.target?.closest?.('[data-pdh-cart-addon-dismiss]');
    if (!button) return;
    const card = button.closest('[data-pdh-cart-addon]');
    if (!card) return;
    event.preventDefault();
    event.stopPropagation();

    // Dismiss the current suggestion in both cart views if both are on the page.
    // A newly rendered suggestion after an add/remove/quantity update is NOT hidden.
    const variantId = card.querySelector('[data-pdh-variant-id]')?.getAttribute('data-pdh-variant-id');
    document.querySelectorAll('[data-pdh-cart-addon]').forEach((otherCard) => {
      const otherId = otherCard.querySelector('[data-pdh-variant-id]')?.getAttribute('data-pdh-variant-id');
      if (otherCard === card || (variantId && otherId === variantId)) {
        otherCard.style.setProperty('display', 'none', 'important');
      }
    });
  }, true);
})();
